"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var state_1 = require("./state");
var actions_1 = require("./actions");
var getters_1 = require("./getters");
var mutations_1 = require("./mutations");
var VuexLoaderStore = /** @class */ (function () {
    function VuexLoaderStore(config) {
        this.namespaced = true;
        this.name = "vuexLoader";
        this.state = state_1.default;
        this.actions = actions_1.default;
        this.getters = getters_1.default;
        this.mutations = mutations_1.default(config);
    }
    return VuexLoaderStore;
}());
exports.default = VuexLoaderStore;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvc3RvcmUvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSxpQ0FBNEI7QUFDNUIscUNBQWdDO0FBQ2hDLHFDQUFnQztBQUNoQyx5Q0FBb0M7QUFFcEM7SUFRRSx5QkFBWSxNQUFNO1FBQ2hCLElBQUksQ0FBQyxVQUFVLEdBQUcsSUFBSSxDQUFDO1FBQ3ZCLElBQUksQ0FBQyxJQUFJLEdBQUcsWUFBWSxDQUFDO1FBQ3pCLElBQUksQ0FBQyxLQUFLLEdBQUcsZUFBSyxDQUFDO1FBQ25CLElBQUksQ0FBQyxPQUFPLEdBQUcsaUJBQU8sQ0FBQztRQUN2QixJQUFJLENBQUMsT0FBTyxHQUFHLGlCQUFPLENBQUM7UUFDdkIsSUFBSSxDQUFDLFNBQVMsR0FBRyxtQkFBUyxDQUFDLE1BQU0sQ0FBQyxDQUFDO0lBQ3JDLENBQUM7SUFDSCxzQkFBQztBQUFELENBQUMsQUFoQkQsSUFnQkMifQ==